<div class="n-breadcrumb d-flex align-items-center justify-content-between">
  <ol class="breadcrumb m-0 bg-transparent p-0">
    <li class="breadcrumb-item"><a href="/#/dealer/home">Home</a></li>
    <li [hidden]="!viewdealerinfo" class="breadcrumb-item"><a href="javascript:;" (click)="backtogrid()">Manage
        Dealers</a></li>
    <li [hidden]="viewdealerinfo" class="breadcrumb-item active">Manage Dealers</li>
  </ol>
  <div class="breadcrumb-toolbar" [hidden]="!viewdealerinfo">
    <a (click)="backtogrid()" class="font-size-sm"><i class="la la-angle-left"></i> Back</a>
  </div>
</div>
<div [hidden]="viewdealerinfo">
  <div class="panel-tile main-title d-flex align-items-center justify-content-between">
    <h3 style="border: 0px !important;margin: 0;padding: 0 !important;" i18n>Manage Dealers </h3>
    <button class="btn btn-primary" (click)="AddDealer('00000000-0000-0000-0000-000000000000')">
      <i _ngcontent-c12="" class="icon wb-plus"></i>&nbsp; Add Dealer
    </button>
  </div>
  <div class="panel-group search-criteria mb-1" id="accordion" role="tablist" aria-multiselectable="true">
    <div class="panel panel-default bg-white m-0">
      <div class="panel-heading" role="tab" id="headingTwo" (click)="searchClick(show=!show)" data-toggle="collapse"
        data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
        <h6 class="panel-title1 d-flex align-items-center justify-content-between"
          style="padding: 11px 15px; line-height: 1.1; font-size: 15px;">
          <span>Search Criteria</span>
          <a class="collapsed" role="button" style="font-size: 22px;">
            <i class="{{toggleClass}}"></i>
          </a>
        </h6>
      </div>
      <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
        <div class=" form-group d-flex p-2 ">
          <div class="d-inline-block m-2">
            <select class="form-control" [(ngModel)]="oem" (change)="bindDealerInfo()">
              <option value="All" selected>All OEM's</option>
              <option *ngFor="let oem of Oems" [value]="oem.OemCode">
                {{oem.OemCode}}</option>
            </select>
          </div>
          <div class="d-inline-block m-2">
            <select class="form-control" [(ngModel)]="dataSourceId" (change)="bindDealerInfo()">
              <option value="All" selected>All DMS Sources</option>
              <option *ngFor="let ds of dlrSource" [value]="ds.DealerSourceTypeId">
                {{ds.DealerSource}}</option>
            </select>
          </div>
          <div class="d-inline-block m-2">
            <select class="form-control" [(ngModel)]="legacySourceId" (change)="bindDealerInfo()">
              <option value="0" selected>All Legacy Sources</option>              
              <option *ngFor="let ds of legacySource" [value]="ds.SourceOfDealer">
                {{ds.SourceOfDealer}}</option>
            </select>
          </div>
          <div class="d-inline-block m-2 ">
            <div class="input-group mb-3">
              <input type="text" class="form-control" style="width: 246px;" (keyup.enter)="bindDealerInfo()" [(ngModel)]="searchText"
                placeholder="Search by Natural Key or Dealer Name" aria-label="Recipient's username" aria-describedby="button-addon2">
            </div>
          </div>
          <div class="d-inline-block m-2 ">
            <div class="input-group-append" (click)="bindDealerInfo()">
              <button class="btn btn-primary" type="submit" id="button-addon2" #searchtxt>Search</button>
            </div>
          </div>
        </div>
        <div class="panel-heading">
          <h6 class="panel-title1 d-flex align-items-center justify-content-between"
          style="padding: 11px 15px; line-height: 1.1; font-size: 15px;">
          <span>Sort By</span><br>
         </h6>
        </div>
        <div class="form-group d-flex p-2 ">
          <div class="d-inline-block m-2">
            <div class="input-group mb-3">
              <select class="form-control" [(ngModel)]="sortValue">
                <option value="updateddt" selected>Last Updated Date</option>
                <option value="dealername">Dealer Name</option>
                <option value="service">Last Service Date</option>
                <option value="sale">Last Sale Date</option>
                <option value="oemcode">OEM</option>
                <option value="naturalkey">Natural Key</option>
              </select>
            </div>
          </div>
          <div class="d-inline-block m-2">
            <div class="input-group mb-3">
              <select class="form-control" [(ngModel)]="mode">
                <option value="desc" selected>Descending</option>
                <option value="asc">Ascending</option>
              </select>
            </div>
          </div>
          <div class="d-inline-block m-2">
            <div class="input-group-append" (click)="sortChange()">
              <button class="btn btn-primary" type="submit" id="button-addon2" #searchtxt>Sort</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="tcard" style="box-shadow: 0 0 0 #eee;">
    <div class="tcard-body">
      <div class="prime-table p-0">
        <p-table #dt [columns]="dealerCols" [value]="dealers" [rows]="20" [responsive]="true" class="mytable"
          emptymessage="customMessage" dataKey="NaturalKey" id="dealerGrid" >
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th width="8%">Actions</th>
              <th width="8%">OEM</th>
              <th width="10%">Natural Key</th>
              <th width="30%">Dealer Name</th>
              <th width="11%">Sources</th>
              <th width="">Type</th>
              <th width="20%">Date 
                <button type="button" class="btn" pButton (click)="downloadexcel(1)" style="float:right"
                data-toggle="tooltip" data-placement="top" title="Export to Excel">
                  <i class="fa fa-file-excel-o" aria-hidden="true" style="font-size: 24px;"></i>
                </button>
              </th>
              <!-- <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                {{col.header}}
                <span *ngIf="col.field != 'Actions' && col.field != 'Expand'">
                 
                </span>
              </th> -->
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
            <tr>
              <td>
                <div class="tcol-actions">
                  <span class="action-edit text-primary" (click)="AddDealer(rowData.DealerGuid)">
                    <i class="flaticon2-writing" title="Edit"></i>
                  </span>
                  <span class="action-delete text-danger"  *ngxPermissionsOnly="['SuperAdmin','Admin']" (click)="DeleteDealer(rowData.DealerGuid)">
                    <i class="flaticon-delete-1" title="Delete"></i>
                  </span>
                </div>
              </td>
              <td>{{rowData.OemCode}}</td>
              <td>{{rowData.NaturalKey}}</td>
              <td>
              <span style="font-weight: 900;"> {{rowData.DealerName}}</span><br><span style="font-size: 11px;">  {{rowData.Address1}} {{rowData.Address2}}, {{rowData.City}}, {{rowData.State}}, {{rowData.Zip}}
               </span>
              </td>
              <td colspan="2" *ngIf="rowData.ListDealerMapping.length >0">
                <table class="mytable">
                  <tr *ngFor="let dm of rowData.ListDealerMapping" >
                      <td >{{dm.DealerSource}}</td>
                      <td >{{dm.SourceType}}</td>
                      <!-- <td >Last Sale Date: {{dm.LastSaleDate | date : "MM-dd-yyyy"}}<br> Last Service Date {{dm.LastRODate | date : "MM-dd-yyyy"}}</td> -->
                  </tr>
                </table>
              </td>
              <td *ngIf="rowData.ListDealerMapping.length >0">
                <span >
                   <b> Last Sale Date:</b>
                  <span *ngFor="let llsale of rowData.ListLastSaleDates" >
                    {{llsale.LastSaleDate | date : "MM-dd-yyyy"}}
                  </span>
                  <bR><b>Last Service Date:</b>
                  <span *ngFor="let llserv of rowData.ListLastServiceDates" >
                    {{llserv.LastServiceDate | date : "MM-dd-yyyy"}}
                  </span>
                </span>
                
                <!-- Last Sale Date: {{rowData.ListLastSaleDates[0].LastSaleDate | date : "MM-dd-yyyy"}}<br> Last Service Date {{rowData.ListLastServiceDates[0].LastServiceDate | date : "MM-dd-yyyy"}} -->
              </td>
              <td colspan="3" *ngIf="rowData.ListDealerMapping.length <=0">
                Not Enrolled
              </td>
              
              <!-- <td *ngFor="let col of columns">
                {{rowData[col.field]}}
                <div *ngIf="col.field == 'Actions'" class="tcol-actions">
                  <span class="action-edit text-primary" (click)="AddDealer(rowData.DealerGuid)">
                    <i class="flaticon2-writing" title="Edit"></i>
                  </span>
                  <span class="action-delete text-danger" (click)="DeleteDealer(rowData.DealerGuid)">
                    <i class="flaticon-delete-1" title="Delete"></i>
                  </span>
                </div>
              </td> -->
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  <!-- pager -->
  <div class="customer-list-pagination">
    <ul *ngIf="pager && pager.pages && pager.pages.length" class="pagination">
      <li [ngClass]="{disabled:pager.currentPage === 1}">
        <a (click)="setPage(1)">
          <span class="fa fa-step-backward"></span>
        </a>
      </li>
      <li [ngClass]="{disabled:pager.currentPage === 1}">
        <a (click)="setPage(pager.currentPage - 1)">
          <span class="fa fa-backward"></span>
        </a>
      </li>
      <span class="paginator-numbers">
        <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
          <a (click)="setPage(page)">{{page}}</a>
        </li>
      </span>
      <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
        <a (click)="setPage(pager.currentPage + 1)">
          <span class="fa fa-forward"></span>
        </a>
      </li>
      <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
        <a (click)="setPage(pager.totalPages)">
          <span class="fa fa-step-forward"></span>
        </a>
      </li>
      <select class="selectbox-page" [(ngModel)]="NoofPages" (change)="onChange($event,pager.currentPage)">
        <option [value]="5">5</option>
        <option [value]="10">10</option>
        <option [value]="20">20</option>
      </select>
    </ul>
  </div>
  <p-dialog class="confirm-delete-modal required-modal" header="Delete Dealer" [(visible)]="displayDlrDltDialog"
    [responsive]="true" showEffect="fade" [modal]="true">
    <form class="deletedealer-form" novalidate [formGroup]="DealerDeleteForm">
      <div class="col-md-12" style="padding-bottom: 20px;">
        <div class="row">
          <div class="form-group col-md-12">
            Are you sure you want to delete this dealer?
          </div>
          <div class="form-group col-md-12">
            <input type="textarea" class="form-control" formControlName="DeleteComments"
              placeholder="Please enter comments.." rows="1"  style="height:50px !important"  />
          </div>
          <div class="form-group col-md-12 ">
            <button type="submit" class="btn btn-primary" (click)="NoDlr()" href="javascript:;">No</button>
            <button type="submit" [disabled]='!DealerDeleteForm.valid || DealerDeleteForm.controls.DeleteComments.value == null' class="btn btn-primary m-2" (click)="YesDlrDlt()" href="javascript:;">Yes</button>
          </div>
        </div>
      </div>
    </form>
  </p-dialog>
  <style>
    .panel-group .panel-title {
      border-bottom: none !important;
      font-size: 30px !important;
    }
  </style>
  <style>
    .customer-list-pagination {
      padding: 20px !important;
      background: #f8f9fb;
      border-color: #f8f9fb !important;
    }

    .customer-list-pagination .pagination {
      justify-content: center;
      margin-bottom: 0px;
    }

    .customer-list-pagination .pagination .disabled {
      width: auto;
    }

    .customer-list-pagination select.selectbox-page {
      margin-left: 10px;
      padding: 2px 10px;
      min-width: 60px;
      margin-top: -5px;
      border-color: #dfe1e4;
    }

    .customer-list-pagination .pagination li a {
      border: 0px;
      padding: 0.3rem 0.75rem;
      border: 1px solid #fff;
    }

    .paginator-numbers {
      display: inline-flex;
      margin: 0 20px;
    }

    .customer-list-pagination .pagination li.active a,
    .customer-list-pagination .pagination li.active:hover a {
      background-color: #186ba0;
      border-color: #fff;
      color: #fff;
    }
    .mytable table
    {
      border-collapse:collapse;
    }
    .mytable tr
    {
      padding:2px;
      /* border: 1px solid #e1e7ec; */
    }
    /* .mytable tr td
    {
      padding:2px;
    } */
    /* .mytable tr.last
    {
      border-bottom: none;
    } */
    .mytable tr:last-child { border-bottom-style:hidden; }
  </style>